

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { AxiosVue } from '@/AxiosVue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy, Accion } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue';
@Component({
  components: {
    ModalMantenedor,
    CabeceraModal,
    ContenidoModal,
    Confirmation,
  },
})
export default class CorregirCumplimientos extends Vue {
  @Prop({ required: true }) show: boolean;
  @Prop({ required: false, default: () => ({}) }) data: any;
  transportista: string = '';
  flota: string = '';
  patente: string = '';
  datoenvio: string = '';
  medidas: string = '';
  respuestaEnvio: string = '';
  readonly $snotify: Snotify;
  boton = false;
  cod_vehiculo: number = 0;
  motor: number = 0;
  json_final: any = {};
  confirmationTitle = 'Confirmar Data';
  confirmationMessage = '¿Está seguro de que desea enviar la data corregida?';
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  showDialog = false;
  filaEstados: { [key: number]: any } = {};

  @Watch('data', { immediate: true, deep: true })
  onDataChanged(newData: any) {
    if (newData) {
      console.log('data ha cambiado:', newData);
      this.transportista = newData.nom_transportista;
      this.flota = newData.flota;
      this.patente = newData.patente_vehiculo;
      this.cod_vehiculo = newData.cod_vehiculo;
      this.motor = newData.motorws;

      // Verificar si ya hay estado guardado para la fila actual
      if (this.filaEstados[this.cod_vehiculo]) {
        const estado = this.filaEstados[this.cod_vehiculo];
        this.datoenvio = estado.datoenvio;
        this.medidas = estado.medidas;
        this.respuestaEnvio = estado.respuestaEnvio;
      } else {
        this.datoenvio = '';
        this.medidas = '';
        this.respuestaEnvio = '';
        this.cargarenvio();
      }
    }
  }
  cargarenvio() {
    console.log('Llamando a cargarenvio...');
    this.axios.http
      .post('Metabase/PostgenericA/certificador_bhp/corregirEnvio', {
        cod_vehiculo: this.cod_vehiculo,
        motor: this.motor,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.json_final = response.data.json_ok;
          this.datoenvio = JSON.stringify(response.data.json_ok, null, 2);
          this.medidas = `<ul>${this.formatMedidas(
            response.data.msg_correccion
          )}</ul>`;
          console.log('Datos Comparativa: ', this.datoenvio);
          console.log('Dato motor enviado: ', this.motor);
        } else {
          console.error(
            'Error al cargar los datos de la tabla:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      })
      .finally(() => {});
  }

  formatMedidas(medidas: any): string {
    return medidas
      .map((medida: any) => {
        return `<li><strong>${medida.item}:</strong> ${medida.Mensaje}</li>`;
      })
      .join('');
  }

  enviarDatos() {
    this.axios.http
      .post('Metabase/PostgenericA/certificador_bhp/enviarDatos', {
        json_final: this.json_final,
        motor: this.motor,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          const parsedResponse = JSON.parse(response.data.respuesta);
          this.respuestaEnvio = JSON.stringify(
            parsedResponse.RespuestaServicioWeb.RespuestaOperacion
              .ResultadoTransaccion,
            null,
            2
          );
          this.$nextTick(() => {
            const textarea = this.$refs.respuestaEnvioTextarea as any;
            if (textarea && textarea.$el) {
              textarea.$el.scrollIntoView({ behavior: 'smooth' });
            }
          });
          this.$snotify.success('Data enviada con exito');
          console.log('Datos enviados correctamente');
          this.$emit('update:value', false); // Cerrar el modal y redirigir a la pantalla principal
        } else {
          this.respuestaEnvio = `Error: ${response.data.MENSAJE_RESPUESTA}`;
          this.$snotify.error(
            `Error al enviar los datos: ${response.data.MENSAJE_RESPUESTA}`
          );
          console.error(
            'Error al enviar los datos:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      });
  }

  adjustTextareaHeight() {
    const textareas = ['textarea', 'medidasTextarea'];
    textareas.forEach(ref => {
      const textarea = this.$refs[ref] as any;
      if (textarea && textarea.$el) {
        const el = textarea.$el.querySelector('textarea');
        if (el) {
          el.style.height = 'auto';
          el.style.height = `${el.scrollHeight}px`;
        }
      }
    });
  }

  showConfirmation() {
    this.showDialog = true;
  }
  handleConfirmationResponse(confirmed: boolean) {
    if (confirmed) {
      this.enviarDatos();
    }
    this.showDialog = false;
  }
  mounted() {
    this.adjustTextareaHeight();
  }

  updated() {
    this.adjustTextareaHeight();
  }
  handleCerrar() {
    this.$emit('update:value', false);
  }
  handleSubmit() {
    // Lógica para manejar el envío del formulario
    console.log('Datos enviados: ', {
      transportista: this.transportista,
      flota: this.flota,
      patente: this.patente,
      cod_vehiculo: this.cod_vehiculo,
      motorws: this.motor,
    });
  }
}
